import { render, staticRenderFns } from "./ListNotes.vue?vue&type=template&id=408971e5&scoped=true&"
import script from "./ListNotes.ts?vue&type=script&lang=ts&"
export * from "./ListNotes.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408971e5",
  null
  
)

export default component.exports